import React, { forwardRef } from 'react';
import { string, any, bool, func } from 'prop-types';
import Link from '../Link';
/**
 * MenuLink component.
 */

var MenuLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var activeClass = _ref.activeClass,
      inverted = _ref.inverted,
      styled = _ref.styled,
      absoluteUrl = _ref.absoluteUrl,
      relativeUrl = _ref.relativeUrl,
      newTab = _ref.newTab,
      xfn = _ref.xfn,
      title = _ref.title,
      children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      aria = _ref.aria,
      tabIndex = _ref.tabIndex,
      role = _ref.role;
  return /*#__PURE__*/React.createElement(Link, {
    activeClass: activeClass,
    inverted: inverted,
    styled: styled,
    className: className,
    href: absoluteUrl || relativeUrl,
    target: newTab ? '_blank' : null,
    rel: xfn,
    title: title || null,
    onClick: onClick,
    onKeyDown: onKeyDown,
    aria: aria,
    tabIndex: tabIndex,
    role: role,
    ref: ref
  }, children);
});
MenuLink.displayName = 'MenuLink';
MenuLink.defaultProps = {
  activeClass: null,
  className: null,
  absoluteUrl: null,
  relativeUrl: null,
  newTab: null,
  xfn: null,
  title: null,
  children: null,
  inverted: null,
  styled: null,
  onClick: null,
  onKeyDown: null,
  aria: null,
  tabIndex: null,
  role: null
}; // The NODE_ENV check normally gets added automatically as part of the build,
// but is here in this case until this issue is sorted.
// https://github.com/oliviertassinari/babel-plugin-transform-react-remove-prop-types/issues/195
//
// We have other components with forwardRef that work fine, not sure what is
// different about this one, but if you're reading this message in a year check
// if that plugin has been patched.

MenuLink.propTypes = process.env.NODE_ENV !== 'production' ? {
  /** Toggles whether the link is active */
  activeClass: string,

  /** Additional class names to add to the component root. */
  className: string,

  /** The children to render inside the link. */
  children: any,

  /** Use the inverted link style. */
  inverted: Link.propTypes.inverted,

  /** Render with the standard link styling. */
  styled: Link.propTypes.styled,

  /** An absolute URL. */
  absoluteUrl: Link.propTypes.href,

  /** A relative URL. */
  relativeUrl: Link.propTypes.href,

  /** Open the URL in a new tab. */
  newTab: bool,

  /** The link relationship
   (see https://codex.wordpress.org/Defining_Relationships_with_XFN). */
  xfn: Link.propTypes.rel,

  /** The link title, to be rendered as a tooltip. */
  title: Link.propTypes.title,

  /** On click event handler. */
  onClick: func,

  /** On key down event handler. */
  onKeyDown: func,

  /** ARIA attributes. */
  aria: Link.propTypes.aria,

  /** The HTML tab index. */
  tabIndex: Link.propTypes.tabIndex,

  /** An ARIA role. */
  role: Link.propTypes.role
} : {};
export default MenuLink;